import { useRoutes } from "react-router-dom";
import { lazy } from "react";
import { LoadComponent } from "@loadComponent";
import { RoomHub } from "_pages/client/desk/RoomHub";
import { ListSuspense } from "_pages/client/components/ListSuspense";
import Error404 from "_pages/other/Error404";

const WaitingRoom = lazy(() => import('./WaitingRoom'));
const ChatRoom = lazy(() => import('./ChatRoom'));
const List = lazy(() => import('./List'));

const Desk = () => {
    return useRoutes([
        {
            path: ':id',
            children: [
                {
                    path: '',
                    element: <LoadComponent component={List} fallback={<ListSuspense />} />,
                },
                {
                    path: 'sala/:deskId',
                    element: <RoomHub />,
                    children: [
                        {
                            path: '',
                            element: <LoadComponent component={WaitingRoom} />
                        },
                        {
                            path: 'atendimento/:attendanceId',
                            element: <LoadComponent component={ChatRoom} />
                        }
                    ]
                },

                {
                    path: '*',
                    element: <Error404 />,
                }
            ],
        },
        {
            path: 'historico/:attendanceId',
            element: <LoadComponent component={ChatRoom} />
        },
    ]);
};


export default Desk;
